import React, { Suspense } from 'react';
import { Outlet } from 'react-router';

import FooterComponent from './FooterComponent';
import Sidebar from './Sidebar';
import { RouteShimmer } from '../shared/shimmer';

const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 60;

const AppLayout: React.FC = () => {
  const [collapsed, setCollapsed] = React.useState(false);
  const currentWidth = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <div
      className="flex h-screen overflow-hidden"
      style={{ backgroundColor: 'var(--bg-primary-app)' }}
    >
      <Suspense fallback={null}>
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((prev) => !prev)}
          width={currentWidth}
        />
      </Suspense>

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <main className="flex flex-1 flex-col overflow-auto">
          <Suspense fallback={<RouteShimmer />}>
            <Outlet />
          </Suspense>
        </main>

        <footer
          className="shrink-0 border-t px-4 py-2.5 text-center"
          style={{ backgroundColor: 'var(--bg-primary)', borderColor: 'var(--border-light)' }}
        >
          <Suspense fallback={null}>
            <FooterComponent />
          </Suspense>
        </footer>
      </div>
    </div>
  );
};

export default AppLayout;
